"use client";
import React from "react";
import { Progress } from "@heroui/progress";

import useTopLoader from "./useTopLoader";

const TopLoader = () => {
  const { isLoading } = useTopLoader();

  return (
    <div className="fixed top-0 left-0 right-0 z-50 ">
      {isLoading && (
        <Progress
          isIndeterminate
          aria-label="loader"
          color="primary"
          size="sm"
        />
      )}
    </div>
  );
};

export default TopLoader;
